const certificationsList = [
    {
        title: "Software Engineering Certification",
        instructor: "Moringa School",
        link: "/certificates/certificate.jpg", 
        platform: "Moringa School",
        date: "November 2024", // Adding the date for context
        description: "Recognized for completing a comprehensive program in software engineering, including full-stack web development, data structures, and algorithms."
    },
    {
        title: "Introduction to Computer Studies",
        instructor: "African Complink College",
        link: "/certificates/intro-to-computer.jpg", // Add the path to your second certificate if available
        platform: "African Complink College",
        date: "March 2024", // Adding the date for this course
        description: "Completed foundational training in computer studies, covering topics like MS Office, networking, and keyboarding."
    }
];

const CertificatesData = { certificationsList };
export default CertificatesData;
